import { z } from "zod";

const minShortDescriptionLength = 16;
const minBriefLength = 40;
const maxBriefLength = 1200;
const maxShortDescriptionLength = 256;

export const MeetingActionItemSchema = z.object({
  short_description: z
    .string()
    .min(minShortDescriptionLength)
    .max(maxShortDescriptionLength)
    .describe(
      "A self-sufficient description of one atomic unfinished action, naming both the action and its subject. Must be 16-256 characters."
    ),
  excerpt: z
    .string()
    .describe(
      "A short span copied verbatim from the meeting notes that records this unfinished action. It must appear in the notes character for character."
    ),
  brief: z
    .string()
    .min(minBriefLength)
    .max(maxBriefLength)
    .describe(
      "Two to four sentences explaining what remains to do, the relevant context or reason in the notes, and what finishing it looks like. Must be 40-1200 characters and contain no invented detail or restatement of the title."
    ),
  owner_email: z
    .string()
    .optional()
    .describe(
      "Email of the attendee clearly named in the notes as owning this item. Omit when nobody is named."
    ),
  due_date: z
    .string()
    .optional()
    .describe(
      "Due date as YYYY-MM-DD, resolved against the meeting's end date when needed. Omit unless the notes state a deadline."
    ),
  detected_creation_rationale: z
    .string()
    .describe(
      "Why this recorded item is concrete unfinished work that the owner must act on, including when it comes from a Remaining work, Next steps, TODO, Action items, Follow-ups, or similar list."
    ),
});

export type MeetingActionItem = z.infer<typeof MeetingActionItemSchema>;
